import { render, staticRenderFns } from "./PersonalVacaciones.vue?vue&type=template&id=2a94a094"
import script from "./PersonalVacaciones.vue?vue&type=script&lang=js"
export * from "./PersonalVacaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports